//////// GHG 2.2 EA
const twoTwoSchema = {
  title: "2.2 Indirect Emissions from Purchased/Acquired Steam",
  addAPI: "cat2_2AddEmissionActivityAPI",
  cat: "cat2_2",
  EATitle: "Emission Activity",
  fields: [
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Energy Supplier or Region",
      resetOnChange: false,
      required: true,
    },
    {
      key: "activityId",
      level: 1,
      type: "select",
      label: "Energy Type",
      optionsAPI: "ghg2_2ActivityDropdown",
      required: true,
      resetOnChange: true,
    },
  ],
};

export default twoTwoSchema;
